import { createSlice } from "@reduxjs/toolkit";

const wirelessCongestionLevelChartData = {
  data: {
    series: [
      ["2026-03-03T03:00:00", 0],
      ["2026-03-03T04:00:00", 0],
      ["2026-03-03T05:00:00", 1],
      ["2026-03-03T06:00:00", 2],
      ["2026-03-03T07:00:00", 3],
    ],
  },
};

const wirelessCongestionLevelDeviceList = {
  data: {
    devices: [
      {
        deviceId: "00:11:22:33:00:01",
        deviceName: "AP-Latest-Online",
        timeCongestedPercent: 8.33,
      },
    ],
  },
};

const wirelessCongestionLevelUpdateThreshold = {
  data: {
    threshold: 10,
  },
};

const wiredCongestionLevelChartData = {
  data: {
    series: [
      ["2026-03-03T03:00:00", 0],
      ["2026-03-03T04:00:00", 0],
      ["2026-03-03T05:00:00", 1],
      ["2026-03-03T06:00:00", 2],
      ["2026-03-03T07:00:00", 3],
    ],
  },
};

const wiredCongestionLevelPeakHourly = {
  data: {
    peakhourly: "2026-04-07 08:00:00",
    devices: [
      {
        crcErrorNum: 0,
        deviceId: "00:11:22:33:00:04",
        deviceName: "SW-Latest-Online",
        dropRatePerSec: 10,
        portId: 1,
        usagePercent: 72,
      },
    ],
  },
};

const wiredCongestionLevelDeviceList = {
  data: {
    portList: [
      {
        crcErrorNum: 10,
        dropRatePerSec: 10,
        portId: 1,
        usagePercent: 72,
      },
    ],
  },
};

const wiredCongestionLevelUpdateThreshold = {
  data: {
    threshold: 37,
  },
};

const wiredLinkDegradationChartData = {
  data: {
    degradedPorts: 4,
    series: [
      [
        "2026-03-03T03:00:00",
        {
          healthy: 10,
          degraded: 2,
          down: 3,
        },
      ],
      [
        "2026-03-03T04:00:00",
        {
          healthy: 10,
          degraded: 2,
          down: 3,
        },
      ],
      [
        "2026-03-03T05:00:00",
        {
          healthy: 10,
          degraded: 2,
          down: 3,
        },
      ],
    ],
  },
};

const wiredLinkDegradationPortList = {
  data: {
    portList: [
      {
        deviceId: "00:11:22:33:00:04",
        deviceName: "SW-Latest-Online",
        ports: [1],
        baseSpeed: 5,
        currentSpeed: 4,
        status: "degraded",
      },
      {
        deviceId: "00:11:22:33:00:04",
        deviceName: "SW-Latest-Online",
        ports: [1],
        baseSpeed: 5,
        currentSpeed: 3,
        status: "down",
      },
    ],
  },
};

const wiredCableQualityChartData = {
  data: {
    noisyPorts: 2,
    series: [
      ["2026-03-30T02:00:00", 0],
      ["2026-03-30T03:00:00", 0],
      ["2026-03-30T04:00:00", 0],
      ["2026-03-30T05:00:00", 0],
      ["2026-03-30T06:00:00", 0],
      ["2026-03-30T07:00:00", 1],
      ["2026-03-30T08:00:00", 2],
    ],
  },
};

const wiredCableQualityPortList = {
  data: {
    errorPortList: [
      {
        crcErrorNum: 1111,
        currentSpeed: 1,
        deviceId: "00:11:22:33:00:04",
        deviceName: "SW-Latest-Online",
        portId: 2,
      },
      {
        crcErrorNum: 111,
        currentSpeed: 4,
        deviceId: "00:11:22:33:00:04",
        deviceName: "SW-Latest-Online",
        portId: 1,
      },
    ],
  },
};

const channelInterferenceChartData = {
  data: {
    noisyAps: 8,
    avgRssi: -70,
    threshold: -85,
    series: [
      ["--85", 10],
      ["-80--85", 11],
      ["-75--80", 12],
      ["-70--75", 14],
      ["-70-", 14],
    ],
  },
};

const channelInterferenceApList = {
  data: {
    apList: [
      {
        ssidName: "<SSID_NAME>",
        channel: 6,
        rssi: -70,
      },
      {
        ssidName: "<SSID_NAME>",
        channel: 8,
        rssi: -75,
      },
      {
        ssidName: "<SSID_NAME>",
        channel: 11,
        rssi: -80,
      },
    ],
  },
};

const channelInterferenceUpdateThreshold = {
  data: {
    threshold: -85,
  },
};

const initialState = {
  wirelessCongestionLevelChartData,
  wirelessCongestionLevelDeviceList,
  wirelessCongestionLevelUpdateThreshold,
  wiredCongestionLevelChartData,
  wiredCongestionLevelPeakHourly,
  wiredCongestionLevelDeviceList,
  wiredCongestionLevelUpdateThreshold,
  wiredLinkDegradationChartData,
  wiredLinkDegradationPortList,
  wiredCableQualityChartData,
  wiredCableQualityPortList,
  channelInterferenceChartData,
  channelInterferenceApList,
  channelInterferenceUpdateThreshold
};

export const ainsightLinkIntegritySlice = createSlice({
  name: "ainsightLinkIntegrity",
  initialState,
  reducers: {},
});

export default ainsightLinkIntegritySlice.reducer;
